<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="'/office/association'">chevron_left</mat-icon>
            <h1 class="page-title">{{ association.providerName }}</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/association'">Associations</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">{{ association.providerName }}</span>
        </div>
    </div>

    <hr class="mb-5" />

    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
            <button class="nav-link {{activeTab == 'detail' ? 'active':''}}" id="home-tab" data-bs-toggle="tab" data-bs-target="#home"
                    type="button" role="tab">Detail</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link {{activeTab == 'activities' ? 'active':''}}" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile"
                    type="button" role="tab">Activities</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link {{activeTab == 'certifications' ? 'active':''}}" id="certification-tab" data-bs-toggle="tab" data-bs-target="#certification"
                    type="button" role="tab">Certifications</button>
        </li>
    </ul>

    <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade  {{activeTab == 'detail' ? 'show active':''}} py-3" id="home" role="tabpanel">

            <div class="row mt-3">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Association Name</h4>
                    <div class="label-text">{{association.providerName}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Email</h4>
                    <div class="label-text">{{association.email}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Phone</h4>
                    <div class="label-text">{{association.phoneNo}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Registered On</h4>
                    <div class="label-text">{{association.registeredOn | date}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Website</h4>
                    <div class="label-text">{{association.website}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Address</h4>
                    <div class="label-text">{{association.address}}</div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <h4 class="text-color-black-normal-50 label-text">Status</h4>
                    <div class="label-text">{{association.status? 'Active': 'Inactive'}}</div>
                </div>
            </div>

            <div class="row my-5">
                <div class="col-12 ">
                    <button mat-raised-button (click)="goEdit()" class="edit-button">
                        <mat-icon>edit</mat-icon>Edit</button>
                </div>
            </div>

        </div>
        <div class="tab-pane fade  {{activeTab == 'activities' ? 'show active':''}} py-3" id="profile" role="tabpanel">

            <app-association-activity-list
                    [providerId]="activatedRoute.snapshot.params.providerId">
            </app-association-activity-list>

        </div>
        <div class="tab-pane fade  {{activeTab == 'certifications' ? 'show active':''}} py-3" id="certification" role="tabpanel">
            <app-provider-certification-list
                [providerId]="activatedRoute.snapshot.params.providerId">
            </app-provider-certification-list>
        </div>
    </div>


</div>

